export default __webpack_public_path__ + "static/media/napaLogo_horizontal_darkBackground_en.ef6957e3.svg";